//-- Copyright (c) 2021 TMT Insights Group, LLC
import React from 'react';
import { Grid } from '@mui/material';
import { Title, TitleBar } from '@/components/_common';
import TransferQueueDrawer from './TransferQueueDrawer';

const FileManagerTitleBar = () => {
  return (
    <TitleBar>
      <Grid container alignItems="center" justifyContent="space-between">
        <Title>File Manager</Title>
        <Grid item>
          <TransferQueueDrawer />
        </Grid>
      </Grid>
    </TitleBar>
  );
};

export default FileManagerTitleBar;
